// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_taxonomy.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_taxonomy.proto.
 */
export const file_travplaces_v1_admin_taxonomy: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * @generated from message travplaces.v1.CreateRouteStyleRequest
 */
export type CreateRouteStyleRequest = Message<"travplaces.v1.CreateRouteStyleRequest"> & {
  /**
   * JSON object; must include "key"
   *
   * @generated from field: string body_json = 1;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.CreateRouteStyleRequest.
 * Use `create(CreateRouteStyleRequestSchema)` to create a new message.
 */
export const CreateRouteStyleRequestSchema: GenMessage<CreateRouteStyleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 0);

/**
 * @generated from message travplaces.v1.CreateRouteStyleResponse
 */
export type CreateRouteStyleResponse = Message<"travplaces.v1.CreateRouteStyleResponse"> & {
  /**
   * new route_styles.id
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.CreateRouteStyleResponse.
 * Use `create(CreateRouteStyleResponseSchema)` to create a new message.
 */
export const CreateRouteStyleResponseSchema: GenMessage<CreateRouteStyleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 1);

/**
 * @generated from message travplaces.v1.UpdateRouteStyleRequest
 */
export type UpdateRouteStyleRequest = Message<"travplaces.v1.UpdateRouteStyleRequest"> & {
  /**
   * route_styles.id to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * JSON object of the columns to change
   *
   * @generated from field: string body_json = 2;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.UpdateRouteStyleRequest.
 * Use `create(UpdateRouteStyleRequestSchema)` to create a new message.
 */
export const UpdateRouteStyleRequestSchema: GenMessage<UpdateRouteStyleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 2);

/**
 * @generated from message travplaces.v1.UpdateRouteStyleResponse
 */
export type UpdateRouteStyleResponse = Message<"travplaces.v1.UpdateRouteStyleResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.UpdateRouteStyleResponse.
 * Use `create(UpdateRouteStyleResponseSchema)` to create a new message.
 */
export const UpdateRouteStyleResponseSchema: GenMessage<UpdateRouteStyleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 3);

/**
 * @generated from message travplaces.v1.DeleteRouteStyleRequest
 */
export type DeleteRouteStyleRequest = Message<"travplaces.v1.DeleteRouteStyleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteRouteStyleRequest.
 * Use `create(DeleteRouteStyleRequestSchema)` to create a new message.
 */
export const DeleteRouteStyleRequestSchema: GenMessage<DeleteRouteStyleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 4);

/**
 * @generated from message travplaces.v1.DeleteRouteStyleResponse
 */
export type DeleteRouteStyleResponse = Message<"travplaces.v1.DeleteRouteStyleResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteRouteStyleResponse.
 * Use `create(DeleteRouteStyleResponseSchema)` to create a new message.
 */
export const DeleteRouteStyleResponseSchema: GenMessage<DeleteRouteStyleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 5);

/**
 * @generated from message travplaces.v1.CreateThemeRequest
 */
export type CreateThemeRequest = Message<"travplaces.v1.CreateThemeRequest"> & {
  /**
   * JSON object; must include "key"
   *
   * @generated from field: string body_json = 1;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.CreateThemeRequest.
 * Use `create(CreateThemeRequestSchema)` to create a new message.
 */
export const CreateThemeRequestSchema: GenMessage<CreateThemeRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 6);

/**
 * @generated from message travplaces.v1.CreateThemeResponse
 */
export type CreateThemeResponse = Message<"travplaces.v1.CreateThemeResponse"> & {
  /**
   * new route_themes.id
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.CreateThemeResponse.
 * Use `create(CreateThemeResponseSchema)` to create a new message.
 */
export const CreateThemeResponseSchema: GenMessage<CreateThemeResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 7);

/**
 * @generated from message travplaces.v1.UpdateThemeRequest
 */
export type UpdateThemeRequest = Message<"travplaces.v1.UpdateThemeRequest"> & {
  /**
   * route_themes.id to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string body_json = 2;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.UpdateThemeRequest.
 * Use `create(UpdateThemeRequestSchema)` to create a new message.
 */
export const UpdateThemeRequestSchema: GenMessage<UpdateThemeRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 8);

/**
 * @generated from message travplaces.v1.UpdateThemeResponse
 */
export type UpdateThemeResponse = Message<"travplaces.v1.UpdateThemeResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.UpdateThemeResponse.
 * Use `create(UpdateThemeResponseSchema)` to create a new message.
 */
export const UpdateThemeResponseSchema: GenMessage<UpdateThemeResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 9);

/**
 * @generated from message travplaces.v1.DeleteThemeRequest
 */
export type DeleteThemeRequest = Message<"travplaces.v1.DeleteThemeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteThemeRequest.
 * Use `create(DeleteThemeRequestSchema)` to create a new message.
 */
export const DeleteThemeRequestSchema: GenMessage<DeleteThemeRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 10);

/**
 * @generated from message travplaces.v1.DeleteThemeResponse
 */
export type DeleteThemeResponse = Message<"travplaces.v1.DeleteThemeResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteThemeResponse.
 * Use `create(DeleteThemeResponseSchema)` to create a new message.
 */
export const DeleteThemeResponseSchema: GenMessage<DeleteThemeResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 11);

/**
 * @generated from message travplaces.v1.CreateCategoryRequest
 */
export type CreateCategoryRequest = Message<"travplaces.v1.CreateCategoryRequest"> & {
  /**
   * JSON object; must include "key"
   *
   * @generated from field: string body_json = 1;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.CreateCategoryRequest.
 * Use `create(CreateCategoryRequestSchema)` to create a new message.
 */
export const CreateCategoryRequestSchema: GenMessage<CreateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 12);

/**
 * @generated from message travplaces.v1.CreateCategoryResponse
 */
export type CreateCategoryResponse = Message<"travplaces.v1.CreateCategoryResponse"> & {
  /**
   * new categories.id
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.CreateCategoryResponse.
 * Use `create(CreateCategoryResponseSchema)` to create a new message.
 */
export const CreateCategoryResponseSchema: GenMessage<CreateCategoryResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 13);

/**
 * @generated from message travplaces.v1.UpdateCategoryRequest
 */
export type UpdateCategoryRequest = Message<"travplaces.v1.UpdateCategoryRequest"> & {
  /**
   * categories.id to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string body_json = 2;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.UpdateCategoryRequest.
 * Use `create(UpdateCategoryRequestSchema)` to create a new message.
 */
export const UpdateCategoryRequestSchema: GenMessage<UpdateCategoryRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 14);

/**
 * @generated from message travplaces.v1.UpdateCategoryResponse
 */
export type UpdateCategoryResponse = Message<"travplaces.v1.UpdateCategoryResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.UpdateCategoryResponse.
 * Use `create(UpdateCategoryResponseSchema)` to create a new message.
 */
export const UpdateCategoryResponseSchema: GenMessage<UpdateCategoryResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 15);

/**
 * @generated from message travplaces.v1.DeleteCategoryRequest
 */
export type DeleteCategoryRequest = Message<"travplaces.v1.DeleteCategoryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteCategoryRequest.
 * Use `create(DeleteCategoryRequestSchema)` to create a new message.
 */
export const DeleteCategoryRequestSchema: GenMessage<DeleteCategoryRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 16);

/**
 * @generated from message travplaces.v1.DeleteCategoryResponse
 */
export type DeleteCategoryResponse = Message<"travplaces.v1.DeleteCategoryResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteCategoryResponse.
 * Use `create(DeleteCategoryResponseSchema)` to create a new message.
 */
export const DeleteCategoryResponseSchema: GenMessage<DeleteCategoryResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 17);

/**
 * @generated from message travplaces.v1.CreateCategoryGroupRequest
 */
export type CreateCategoryGroupRequest = Message<"travplaces.v1.CreateCategoryGroupRequest"> & {
  /**
   * JSON object; must include "key"
   *
   * @generated from field: string body_json = 1;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.CreateCategoryGroupRequest.
 * Use `create(CreateCategoryGroupRequestSchema)` to create a new message.
 */
export const CreateCategoryGroupRequestSchema: GenMessage<CreateCategoryGroupRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 18);

/**
 * @generated from message travplaces.v1.CreateCategoryGroupResponse
 */
export type CreateCategoryGroupResponse = Message<"travplaces.v1.CreateCategoryGroupResponse"> & {
  /**
   * the group's key
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.CreateCategoryGroupResponse.
 * Use `create(CreateCategoryGroupResponseSchema)` to create a new message.
 */
export const CreateCategoryGroupResponseSchema: GenMessage<CreateCategoryGroupResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 19);

/**
 * @generated from message travplaces.v1.UpdateCategoryGroupRequest
 */
export type UpdateCategoryGroupRequest = Message<"travplaces.v1.UpdateCategoryGroupRequest"> & {
  /**
   * the group's key to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string body_json = 2;
   */
  bodyJson: string;
};

/**
 * Describes the message travplaces.v1.UpdateCategoryGroupRequest.
 * Use `create(UpdateCategoryGroupRequestSchema)` to create a new message.
 */
export const UpdateCategoryGroupRequestSchema: GenMessage<UpdateCategoryGroupRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 20);

/**
 * @generated from message travplaces.v1.UpdateCategoryGroupResponse
 */
export type UpdateCategoryGroupResponse = Message<"travplaces.v1.UpdateCategoryGroupResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.UpdateCategoryGroupResponse.
 * Use `create(UpdateCategoryGroupResponseSchema)` to create a new message.
 */
export const UpdateCategoryGroupResponseSchema: GenMessage<UpdateCategoryGroupResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 21);

/**
 * @generated from message travplaces.v1.DeleteCategoryGroupRequest
 */
export type DeleteCategoryGroupRequest = Message<"travplaces.v1.DeleteCategoryGroupRequest"> & {
  /**
   * the group's key
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteCategoryGroupRequest.
 * Use `create(DeleteCategoryGroupRequestSchema)` to create a new message.
 */
export const DeleteCategoryGroupRequestSchema: GenMessage<DeleteCategoryGroupRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 22);

/**
 * @generated from message travplaces.v1.DeleteCategoryGroupResponse
 */
export type DeleteCategoryGroupResponse = Message<"travplaces.v1.DeleteCategoryGroupResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteCategoryGroupResponse.
 * Use `create(DeleteCategoryGroupResponseSchema)` to create a new message.
 */
export const DeleteCategoryGroupResponseSchema: GenMessage<DeleteCategoryGroupResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_taxonomy, 23);

/**
 * AdminTaxonomyService ports the legacy adminApi taxonomy CRUD: route styles,
 * route themes, categories and category groups, all written against existing
 * tables. Create and Update carry the edited row as a JSON object string
 * (body_json) whose keys mirror the legacy adminApi field names (camelCase),
 * exactly as the previous admin panels sent them; the handler whitelists the
 * keys it accepts per table and builds the SQL. Every call returns the
 * affected row's identifier (the uuid id, or the natural key for category
 * groups, which are keyed by `key`).
 *
 * @generated from service travplaces.v1.AdminTaxonomyService
 */
export const AdminTaxonomyService: GenService<{
  /**
   * ── route styles ──────────────────────────────────────────────────
   *
   * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateRouteStyle
   */
  createRouteStyle: {
    methodKind: "unary";
    input: typeof CreateRouteStyleRequestSchema;
    output: typeof CreateRouteStyleResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateRouteStyle
   */
  updateRouteStyle: {
    methodKind: "unary";
    input: typeof UpdateRouteStyleRequestSchema;
    output: typeof UpdateRouteStyleResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteRouteStyle
   */
  deleteRouteStyle: {
    methodKind: "unary";
    input: typeof DeleteRouteStyleRequestSchema;
    output: typeof DeleteRouteStyleResponseSchema;
  },
  /**
   * ── route themes ──────────────────────────────────────────────────
   *
   * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateTheme
   */
  createTheme: {
    methodKind: "unary";
    input: typeof CreateThemeRequestSchema;
    output: typeof CreateThemeResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateTheme
   */
  updateTheme: {
    methodKind: "unary";
    input: typeof UpdateThemeRequestSchema;
    output: typeof UpdateThemeResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteTheme
   */
  deleteTheme: {
    methodKind: "unary";
    input: typeof DeleteThemeRequestSchema;
    output: typeof DeleteThemeResponseSchema;
  },
  /**
   * ── categories ────────────────────────────────────────────────────
   *
   * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateCategory
   */
  createCategory: {
    methodKind: "unary";
    input: typeof CreateCategoryRequestSchema;
    output: typeof CreateCategoryResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateCategory
   */
  updateCategory: {
    methodKind: "unary";
    input: typeof UpdateCategoryRequestSchema;
    output: typeof UpdateCategoryResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteCategory
   */
  deleteCategory: {
    methodKind: "unary";
    input: typeof DeleteCategoryRequestSchema;
    output: typeof DeleteCategoryResponseSchema;
  },
  /**
   * ── category groups ───────────────────────────────────────────────
   *
   * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateCategoryGroup
   */
  createCategoryGroup: {
    methodKind: "unary";
    input: typeof CreateCategoryGroupRequestSchema;
    output: typeof CreateCategoryGroupResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateCategoryGroup
   */
  updateCategoryGroup: {
    methodKind: "unary";
    input: typeof UpdateCategoryGroupRequestSchema;
    output: typeof UpdateCategoryGroupResponseSchema;
  },
  /**
   * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteCategoryGroup
   */
  deleteCategoryGroup: {
    methodKind: "unary";
    input: typeof DeleteCategoryGroupRequestSchema;
    output: typeof DeleteCategoryGroupResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_taxonomy, 0);

